import { z } from "zod";

export default () => z.object({
    address: z.string().min(1),

    salePrice: z.number().positive(),
    saleDate: z.date(),

    buyerName: z.string().min(1),
    sellerName: z.string().min(1),

    capRate: z.number().nonnegative().nullable(),
    noi: z.number().nonnegative().nullable(),

    landSizeUsable: z.number().positive(),
    parcelSizeAcres: z.number().positive(),
    buildingSize: z.number().nonnegative(),

    propertyType: z.string().min(1),
    dealProfile: z.string().min(1),
    compSource: z.string().min(1),
});